import { useState } from 'react';
import ReactDOMServer from "react-dom/server";
import { AppCard, AppNoInfo, AppRemixIcon } from '@/layout/AppComponents';
import styled from 'styled-components';
import axios from 'axios';
import { Scrollbars } from 'react-custom-scrollbars';
import Translator from '../../../../components/helpers/Translator';
import colors from '../../../../../constants/colors';
import { axiosPath } from '../../../../../routing/helpers/router';
import minions from '../../../../../minions/minions';
import _ from 'lodash';

export default function Report59OnlineInfo(props) {
  const { data } = props;
  const [selectedEvidence, setSelectedEvidence] = useState();

  const handleDownloadFile = async (url = null) => {
    try {
      const response = await axios.post(
        axiosPath("api_r_user_module_legalCompliance_evidences_download"),
        {
          evidenceID: selectedEvidence.id,
          url,
        }
      );
      window.open(response.data, "_blank");
      return response.data;
    } catch (err) {}
  };

  return (
    <div className="row  mt-3">
      <div className="col-xl-12">
        <AppCard
          header={
            <div className="d-flex justify-content-between">
              <div>
                <Translator file="module-legalCompliance" name="evidences" />
              </div>
              <div>
                <a
                  href={data['onlineInfo']['urlFile']}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Descargar Excel
                </a>
              </div>
            </div>
          }
        >
          <div>
            {Object.keys(data['onlineInfo']['evidences']).length > 0 ? (
              <EvidenceTabContainer>
                <SidebarMenu>
                  <>
                    <Scrollbars style={{ height: '100%' }}>
                      <ul>
                        {_.map(
                          data['onlineInfo']['evidences'],
                          (obligation, obligationKey) =>
                            _.map(obligation, (evidence, key) => (
                              <li
                                key={key}
                                className={
                                  selectedEvidence &&
                                  selectedEvidence.id === evidence.id
                                    ? 'ev-selected'
                                    : ''
                                }
                                onClick={() => setSelectedEvidence(evidence)}
                              >
                                <div className="first-row">
                                  <span
                                    className="name"
                                    title={
                                      evidence.name || evidence.description
                                    }
                                  >
                                    {evidence.name || evidence.description}
                                  </span>
                                  <AppRemixIcon
                                    className="mr-2"
                                    icon="attachment-2"
                                    noVariants
                                    color={
                                      evidence.url || evidence?.urls?.length > 0
                                        ? colors.primary
                                        : colors.grey400
                                    }
                                  />
                                </div>
                                <div className="second-row">
                                  <span className="sr-date">
                                    <div>{evidence.plantName}</div>
                                    <div>{evidence.date}</div>
                                    <div>
                                      ID:{evidence.obligation.id} - CODE:{' '}
                                      {obligationKey}
                                    </div>
                                  </span>
                                  <span className="sr-user mr-2">
                                    {evidence.user?.name}
                                  </span>
                                </div>
                              </li>
                            ))
                        )}
                      </ul>
                    </Scrollbars>
                  </>
                </SidebarMenu>
                <Content>
                  {selectedEvidence && (
                    <>
                      <h3>
                        <Translator
                          file="module-legalCompliance"
                          name="evidence.information.name"
                          variables={{
                            name: selectedEvidence.name,
                          }}
                        />
                        <span
                          className="float-right pointer mr-2"
                          title={ReactDOMServer.renderToString(
                            <Translator
                              file="module-legalCompliance"
                              name="close"
                            />
                          )}
                        >
                          <AppRemixIcon
                            icon="close"
                            size={16}
                            onClick={() => {
                              setSelectedEvidence(null);
                            }}
                          />
                        </span>
                      </h3>
                      <EvidenceInfo className="mt-4">
                        <li>
                          <span className="eventinfo-title">
                            <Translator
                              file="module-legalCompliance"
                              name="name"
                            />
                          </span>
                          <span className="eventinfo-content">
                            {selectedEvidence.name}
                          </span>
                        </li>
                        <li>
                          <span className="eventinfo-title">CODE</span>
                          <span className="eventinfo-content">
                            {selectedEvidence.obligation?.hex}
                          </span>
                        </li>
                        <li>
                          <span className="eventinfo-title">ID</span>
                          <span className="eventinfo-content">
                            {selectedEvidence.obligation?.id}
                          </span>
                        </li>
                        <li>
                          <span className="eventinfo-title">
                            <Translator
                              file="module-legalCompliance"
                              name="associated.files"
                            />
                          </span>
                          <span className="eventinfo-content">
                            {selectedEvidence.urls &&
                            selectedEvidence.urls.length > 0 ? (
                              selectedEvidence.urls.map((url) => (
                                <FileDownload
                                  key={url}
                                  onClick={() => handleDownloadFile(url)}
                                  title={ReactDOMServer.renderToString(
                                    <Translator
                                      file="module-legalCompliance"
                                      name="download.file"
                                    />
                                  )}
                                >
                                  {minions.files.fileIcon(
                                    url,
                                    true,
                                    null,
                                    'mr-2'
                                  )}
                                  {url}
                                </FileDownload>
                              ))
                            ) : (
                              <span>
                                <Translator
                                  file="module-legalCompliance"
                                  name="no.associated.files"
                                />
                              </span>
                            )}
                          </span>
                        </li>
                        <li>
                          <span className="eventinfo-title">
                            <Translator
                              file="user"
                              name="user.obligation.evidence.date"
                            />
                          </span>
                          <span className="eventinfo-content">
                            {selectedEvidence.date ? (
                              selectedEvidence.date
                            ) : (
                              <span className="text-muted">
                                <Translator file="user" name="user.no-date" />
                              </span>
                            )}
                          </span>
                        </li>
                        <li>
                          <span className="eventinfo-title">
                            <Translator
                              file="module-legalCompliance"
                              name="module.lc.evidence.description"
                            />
                          </span>
                          <span
                            className="eventinfo-content"
                            style={{
                              maxWidth: 'calc(100vw - 900px)',
                            }}
                          >
                            {selectedEvidence.description}
                          </span>
                        </li>
                        <li>
                          <span className="eventinfo-title">
                            <Translator
                              file="module-intelligence"
                              name="module.int.installation"
                            />
                          </span>
                          <span className="eventinfo-content">
                            {selectedEvidence.plantName}
                          </span>
                        </li>
                        <li>
                          <span className="eventinfo-title">
                            <Translator
                              file="module-intelligence"
                              name="obligation"
                            />
                          </span>
                          <span
                            className="eventinfo-content"
                            style={{ maxWidth: '80%' }}
                          >
                            {selectedEvidence.obligation.text}
                          </span>
                        </li>
                      </EvidenceInfo>
                    </>
                  )}
                </Content>
              </EvidenceTabContainer>
            ) : (
              <AppNoInfo
                text={
                  <Translator
                    file="module-legalCompliance"
                    name="no.evidences"
                  />
                }
                color={colors.primaryLight}
                icon={
                  <AppRemixIcon
                    size={24}
                    icon="file-search"
                    color={colors.primaryLight}
                  />
                }
              />
            )}
          </div>
        </AppCard>
      </div>
    </div>
  );
}

const EvidenceTabContainer = styled.div`
  height: 450px;
  display: grid;
  grid-template-columns: 450px 1fr;
`;

const SidebarMenu = styled.div`
  overflow-y: auto;
  padding: 0;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  ul {
    padding: 4px;
    overflow-y: auto;
    li {
      padding: 4px 2px;
      border-bottom: 1px solid ${colors.grey300};
      cursor: pointer;
      &.ev-selected {
        background: ${colors.grey300};
      }
      .first-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: ${colors.primary};
        .name {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .second-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 10px;
        .sr-date {
          letter-spacing: 1px;
        }
        .sr-user {
          color: ${colors.primary};
        }
      }
    }
  }
`;

const Content = styled.div`
  border-left: 1px solid ${colors.grey300};
  padding: 4px;
  height: 450px;
  .row-no-margin > .row {
    margin: 0;
  }
`;

const EvidenceInfo = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  height: 350px;
  overflow: auto;
  li {
    padding: 8px 0;
    border-top: 1px solid ${colors.grey300};
    display: flex;
    align-items: baseline;
    .eventinfo-title {
      display: inline-block;
      width: 200px;
      text-transform: uppercase;
      font-weight: bold;
      color: ${colors.primary};
    }
  }
`;

const FileDownload = styled.div`
  &:hover {
    cursor: pointer;
  }
`;
